export default __webpack_public_path__ + "static/media/457b_light.647d23ad.png";